// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".mx-input {\n  color: #6e6b7b;\n}[dir=ltr] .mx-input {\n  padding: 20px 10px 20px 35px;\n}[dir=rtl] .mx-input {\n  padding: 20px 35px 20px 10px;\n}\n[dir=ltr] .mx-icon-calendar {\n  left: 10px\n}\n[dir=rtl] .mx-icon-calendar {\n  right: 10px\n}\n", ""]);
// Exports
module.exports = exports;
